import React, { Component } from 'react';
import Utils from '../utils';
import UI from '../ui';

const { WrappedInputTextWithLabel, Spinner, WrappedButton, WrappedButtonType, InfoBanner } = UI;
const { Logger, Communication, withLayoutAndModalContexts, Util, Session } = Utils;

class ResetPassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			userName:
				Util.getQueryParamByName('username') || Util.getCookie('print_username') || '',
			temporaryPassword: Util.getQueryParamByName('tempPw'),
			newPassword: '',
			newPasswordError: 0,
			errorMessage: '',
			mask: false,
			showSuccess: false,
			validationError: {
				length: -1,
				number: -1,
				specialChar: -1,
				differentFromUsername: -1,
			},
		};
	}

	validatePassword = password => {
		const minLength = 15;
		const maxLength = 64;
		const hasNumber = /\d/;
		const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
		const { userName } = this.state;

		const errors = {
			length: password.length >= minLength && password.length <= maxLength ? 0 : -1,
			number: hasNumber.test(password) ? 0 : -1,
			specialChar: hasSpecialChar.test(password) ? 0 : -1,
			differentFromUsername: password !== userName ? 0 : -1,
		};

		return errors;
	};

	handleInputChange = e => {
		const validationError = this.validatePassword(e.target.value);
		this.setState({
			newPassword: e.target.value,
			newPasswordError: 0,
			validationError,
		});
	};

	onInputTextBlur = () => {
		const { newPassword } = this.state;

		this.setState({
			errorMessage: newPassword ? '' : 'This field is required',
			newPasswordError: newPassword ? 0 : 1,
		});
	};

	isFormValid = () => {
		const { validationError } = this.state;
		return Object.values(validationError).every(value => value === 0);
	};

	onKeyPressEnter = e => {
		const {
			key,
			target: { value },
		} = e;

		if (key === 'Enter' && value !== '') {
			e.preventDefault();

			this.onContinueButtonClick();
		}
	};

	goToSignInView = () => {
		// redirect to Auth0 login page
		const { goToSignInView } = this.props;
		const { showSuccess } = this.state;
		goToSignInView(showSuccess);
	};

	onContinueButtonClick = async () => {
		const { temporaryPassword, newPassword, userName } = this.state;

		Logger.saveActionData('Reset Password Button Clicked');

		this.setState({ mask: true });

		const resetPasswordResponse = await Communication.finishPasswordReset({
			Username: userName,
			Password: temporaryPassword,
			NewPassword: newPassword,
		});

		this.setState({ mask: false });

		if (Communication.isSuccessful(resetPasswordResponse)) {
			this.setState({
				showSuccess: true,
			});
		} else {
			const { ErrorCode, ErrorDescription } = resetPasswordResponse;

			this.setState({
				errorMessage: ErrorDescription,
				newPasswordError: ErrorCode,
			});
		}
	};

	renderContent() {
		const { newPassword, newPasswordError, errorMessage, mask, validationError } = this.state;
		const { length, number, specialChar, differentFromUsername } = validationError;
		return (
			<div className="content">
				<p className="content">Enter your new password.</p>

				<div className="row-container password-input">
					<WrappedInputTextWithLabel
						showErrorBelow
						errorMessage={errorMessage}
						isInputInvalid={!!newPasswordError}
						className="bold-font"
						label="Password"
						uiElementConfig={{
							type: 'password',
							value: newPassword,
							name: 'newPassword',
							onChange: this.handleInputChange,
							onBlur: this.onInputTextBlur,
							onKeyPress: this.onKeyPressEnter,
							required: true,
							dataqa: 'new-password',
						}}
					/>
				</div>
				<div className="password-list">
					<p className="validation-header">A strong password must:</p>
					<ul>
						<li>
							<span className={`affirm ${length === -1 ? 'disabled' : ''}`} />
							Have 15-64 characters
						</li>
						<li>
							<span className={`affirm ${number === -1 ? 'disabled' : ''}`} />
							Include at least one number
						</li>
						<li>
							<span className={`affirm ${specialChar === -1 ? 'disabled' : ''}`} />
							Include at least one special character
						</li>
						<li>
							<span
								className={`affirm ${
									differentFromUsername === -1 ? 'disabled' : ''
								}`}
							/>
							Be different from username
						</li>
					</ul>
				</div>
				{mask && <Spinner msg="Verifying account information..." />}
			</div>
		);
	}

	render() {
		const { newPassword, showSuccess } = this.state;

		return (
			<>
				{showSuccess ? (
					<div className="common-authentication auth-reset-password-view success-message-view">
						<div className="form">
							<div className="primary-header">
								Your Password Has Been Successfully Reset
							</div>
							<div className="content">
								<InfoBanner type="affirm">
									<span className="icon-affirm" />
									<p className="info-content">
										Password reset successful. You can log in with your new
										password.
									</p>
								</InfoBanner>
							</div>

							<div className="row-container centered">
								<WrappedButton
									label="Return to login"
									onClick={this.goToSignInView}
									buttonType={WrappedButtonType.goToSignInView}
									dataqa="return-to-login"
								/>
							</div>
						</div>
					</div>
				) : (
					<div className="common-authentication auth-reset-password-view">
						<div className="form">
							<div className="primary-header">Reset Password</div>
							{this.renderContent()}
							<div className="row-container centered">
								<WrappedButton
									className="continue-button"
									label="Change password"
									onClick={this.onContinueButtonClick}
									onKeyPress={this.onKeyPressEnter}
									buttonType={WrappedButtonType.Primary}
									dataqa="save-change-password"
									disabled={!this.isFormValid()}
								/>
							</div>
							<div className="row-container centered">
								<WrappedButton
									label="Cancel"
									buttonType={WrappedButtonType.TertiaryGhost}
									dataqa="cancel-reset-password"
									onClick={this.goToSignInView}
								/>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}

export default withLayoutAndModalContexts(ResetPassword);
